import { DataField, onFieldValueChange } from '@eastcoal/formily/exports/core'

import { AREA_CODE_HBCOAL } from '@eastcoal/shared/utils/auction'

import { LIMIT_IP_FIELD, STORAGE_PLACE_FIELD } from '../../constants/field'

export const limitIpEffect = () => {
  /**
   * 存放地为“淮北矿业”子孙地址时默认选中并禁止编辑
   */
  onFieldValueChange(STORAGE_PLACE_FIELD, (_, form) => {
    if (form.pattern === 'readPretty') {
      return
    }
    const limitIpField = form.query(LIMIT_IP_FIELD).take() as DataField
    if (form.values.storagePlaceCode?.startsWith(AREA_CODE_HBCOAL)) {
      limitIpField.onInput(true)
      // limitIpField.setPattern('disabled')
    } else {
      limitIpField.setPattern('editable')
    }
  })
}
